import { Trans, useTranslation } from "react-i18next";
import { IAppealLandingProps } from "../../model/interface";
import { Warning24Regular } from '@fluentui/react-icons';
import AppealLandingAlertBody from "../appealAlertBody/AppealLandingAlertBody";
import Alert from "../alert/alert";
import './AppealLanding.scss';
import IconLink from "../IconLink/IconLink";
import { ACCOUNT_APPEAL_EXAMPLE_IMAGE, DIGITALSAFETY_POLICIES_URL, MICROSOFT_CODEOFCONDUNCT_URL } from "../../constants/constants";
import { AppealType } from "../../model/enum";
import { Image } from "@fluentui/react-components";
import { useEffect, useState } from "react";
import { isValidBase64Image } from "../../utils/appealUtil";

export default function AppealLanding(props: IAppealLandingProps) {
    const [imageCanLoad, setImageCanLoad] = useState<boolean>(false);
    const { t } = useTranslation();

    const handleImageLoadingError = () => {
        setImageCanLoad(false);
    }

    useEffect(() => {
        if (!imageCanLoad)
        {
            setImageCanLoad(isValidBase64Image(ACCOUNT_APPEAL_EXAMPLE_IMAGE));
        }
    }
    ,[]); //eslint-disable-line

    return (
        <div>
            <div className="form-overview">
                <h1 className="form-overview__header" data-testid="appeal-landing-header"> {t(props.header)}</h1>
                {props.appealType === AppealType.Content &&
                    <p className="form-overview__paragraph">{t(props.subHeader)}</p>
                }
                {props.appealType === AppealType.Account &&
                    <p className="form-overview__paragraph">
                        <Trans i18nKey={props.subHeader} policies={t('Appeal.Common.policies')} code-of-conduct={t('Appeal.Common.code-of-conduct')}>
                            Sharing content that violates our
                            <IconLink href={DIGITALSAFETY_POLICIES_URL} text={t('Appeal.Common.policies')} />
                            or
                            <IconLink href={MICROSOFT_CODEOFCONDUNCT_URL} text={t('Appeal.Common.code-of-conduct')} />
                            may result in account suspension.
                        </Trans>
                    </p>
                }
                {props.subHeaderTwo &&
                    <p className="form-overview__paragraph">{t(props.subHeaderTwo)}</p>
                }
            </div>
            <div className="appeal-landing-mid">
                <Alert icon={<Warning24Regular />} title={t('Common.landing-note-one')} body={<AppealLandingAlertBody />} />
            </div>
            {(props.appealType === AppealType.Account && imageCanLoad) &&
                <div className="locked-account">
                    <h5 className="locked-account__header" aria-hidden="true">{t('Appeal.Account.locked-account-header')}</h5>
                    <Image className="locked-account__image" alt={t('Appeal.Account.locked-account-alt-text')} fit="contain" shape="rounded" onError={handleImageLoadingError} src={ACCOUNT_APPEAL_EXAMPLE_IMAGE} />
                </div>
            }
        </div >
    );
};
